import Vue from 'vue'
import LazySizes from 'lazysizes'

Vue.use(LazySizes)
